const ROOT_KEY_PATH = ['PeopleImportDialog', 'basicSearch'];

export const query = state => state.getIn([...ROOT_KEY_PATH, 'query']);
